/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../connect/v2/resources/address';
import '../../../legalentities/model/model';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "models": {
                "nested": {
                  "Business": {
                    "fields": {
                      "businessName": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "address": {
                        "type": ".squareup.connect.v2.resources.Address",
                        "id": 2,
                        "rule": "optional"
                      },
                      "businessType": {
                        "type": ".squareup.legalentities.model.Business.Structure.Type",
                        "id": 3,
                        "rule": "optional"
                      },
                      "businessEinLast4": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "llcTaxClassification": {
                        "type": ".squareup.sfs.external.models.Business.LlcTaxClassification",
                        "id": 5,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "LlcTaxClassification": {
                        "values": {
                          "LLC_TAX_CLASSIFICATION_DO_NOT_USE": 0,
                          "C_CORPORATION": 1,
                          "S_CORPORATION": 2,
                          "PARTNERSHIP": 3
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.models?.nested?.Business && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.models?.nested?.Business?.nested?.LlcTaxClassification) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Represents a business on an SFS ApplicationFlow.
 * --
 *
 * SOURCE Business @ squareup/sfs/external/models/business.proto at 12:1
 */
export const Business = $root.lookupType('squareup.sfs.external.models.Business');
fixType(Business);
Builder.createAndAttachToType(Business);
/**
 * SOURCE LlcTaxClassification @ squareup/sfs/external/models/business.proto at 13:3
 */
Business.LlcTaxClassification = $root.lookupEnum('squareup.sfs.external.models.Business.LlcTaxClassification').values;